"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThreeBenefits = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _clsx = _interopRequireDefault(require("clsx"));
var _hooks = require("../../hooks");
var _styles = require("../HeadlineLayout/styles");
var _Benefit = require("./Benefit");
var _BenefitsLayoutClasses = require("./BenefitsLayoutClasses");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ThreeBenefits = ({
  title,
  benefits,
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isTablet = (0, _hooks.useIsTablet)();
  const rootClassName = (0, _clsx.default)(_BenefitsLayoutClasses.benefitsLayoutClasses.threeBenefitsRoot, className);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Root, {
    className: rootClassName,
    "data-testid": getTestId(_constants.BENEFITS_ROOT_THREE),
    children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.LayoutHeader, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Headline, {
        "data-testid": getTestId(_constants.BENEFITS_MAIN_TITLE),
        textAlign: "center",
        variant: "h4",
        component: "h2",
        maxLines: isTablet ? 3 : 2,
        children: title
      })
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.InnerRoot, {
      className: _BenefitsLayoutClasses.benefitsLayoutClasses.innerRoot,
      isInCarousel: false,
      children: benefits.map(benefit => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Benefit.Benefit, {
        benefit: benefit
      }, benefit?.caption))
    })]
  });
};
exports.ThreeBenefits = ThreeBenefits;
